// removed by extract-text-webpack-plugin
module.exports = {"message":"create-password__message___94UbM","title":"create-password__title___3umXg","subTitle":"create-password__subTitle___3e3zZ","button":"create-password__button___20VRh","toolTipEmailRegistration":"create-password__toolTipEmailRegistration___w_e0K","toolTipPasswordToolbox":"create-password__toolTipPasswordToolbox___3BWqA"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/auth/create-password/create-password.scss
// module id = 1244
// module chunks = 0